module.exports = __webpack_public_path__ + "img/send-invite-icon.9e58c3ff.svg";